import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

const tones = {
  neutral: "bg-surface-muted text-ink-muted",
  success: "bg-success-soft text-success-ink",
  danger: "bg-danger-soft text-danger-ink",
  warning: "bg-warning-soft text-warning-ink",
  info: "bg-info-soft text-info-ink",
  violet: "bg-violet-soft text-violet-ink",
  amber: "bg-amber-soft text-amber-ink",
};

const dots = {
  neutral: "bg-ink-subtle",
  success: "bg-success",
  danger: "bg-danger",
  warning: "bg-warning",
  info: "bg-info",
  violet: "bg-violet",
  amber: "bg-amber-ink",
};

export type Tone = keyof typeof tones;

/** Status pill ("Activo", "Suspendido", "+5%"). */
export function Badge({
  tone = "neutral",
  dot,
  className,
  children,
}: {
  tone?: Tone;
  dot?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium",
        tones[tone],
        className,
      )}
    >
      {dot && <span className={cn("size-1.5 rounded-full", dots[tone])} />}
      {children}
    </span>
  );
}

/** Small numeric counter next to a nav item, tab or title. */
export function Count({ children, inverted }: { children: ReactNode; inverted?: boolean }) {
  return (
    <span
      className={cn(
        "tabular inline-flex min-w-5 items-center justify-center rounded-md px-1 text-[11px] font-medium leading-5",
        inverted ? "bg-white/90 text-dark" : "bg-line text-ink-muted",
      )}
    >
      {children}
    </span>
  );
}
